import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import "tailwindcss/tailwind.css";
import { Empty } from "antd";
import "../../../../src/styles.css";
import Vectorsorting from "../../../assets/Vectorsorting.svg";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ShimmerLoader from "../../../loading";
import CustomPagination from "../../../components/CustomWidgets/CustomPagination";
import { useSelector } from "react-redux";

const InventoryWiseTable = ({ additionalData, pagination, onRowClick }) => {
    const { t } = useTranslation();
    const [flag, setFlag] = useState(false);
    const navigate = useNavigate();

    const allStores = useSelector(
        (state) => state?.storeReducer?.selectedStore?.is_select_all_store
    );

    const data = useMemo(() => additionalData || [], [additionalData]);

    useEffect(() => {
        if (additionalData?.length === 0 && !flag) {
            const timer = setTimeout(() => {
                setFlag(true);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [additionalData, flag]);

    const columns = useMemo(
        () => [
            // {
            // Header: t("Session"),
            // accessor: "session_name",
            // width: 180,
            // },
            {
                Header: t("Session"),
                accessor: "session_name",
                width: 180,
                Cell: ({ value }) => {
                    if (!value) return "";

                    const [prefix, suffix] = value.split("/");

                    return `${t(prefix)}${suffix ? " / " + suffix : ""}`;
                },
            },
            {
                Header: t("Date & Time"),
                accessor: "sale_date",
                width: 150,
            },
            // {
            //     Header: t("Order Type"),
            //     accessor: "order_type",
            //     width: 120,
            //     Cell: ({ row }) => t(row.original.order_type),
            // },
            {
                Header: t("Barcode"),
                accessor: "barcode",
                width: 120,
            },
            {
                Header: t("Product Name"),
                accessor: "product_name",
                width: 180,
                  Cell: ({ row }) => (
          <div className="text-start">{row.original.product_name2 && row.original.product_name2 != '' ?  row.original.product_name2 : row.original.product_name}</div>
        ),
            },
            // {
            //     Header: t("Custom Name"),
            //     accessor: "product_name2",
            //     width: 180,
            // },
            {
                Header: t("Group Name"),
                accessor: "group_name",
                width: 180,
            },
            // {
            //     Header: t("Category"),
            //     accessor: "category",
            //     width: 150,
            // },
            // {
            //     Header: t("Sub-Category"),
            //     accessor: "sub_category",
            //     width: 150,
            // },
            {
                Header: t("Quantity Sold"),
                accessor: "qty_sold",
                width: 120,
            },
            {
                Header: t("Total Cost"),
                accessor: "total_cost",
                width: 120,
                Cell: ({ row }) => `EGP ${row.original.total_cost?.toFixed(2)}`,
            },
            {
                Header: t("Total Value"),
                accessor: "total_value",
                width: 120,
                Cell: ({ row }) => `EGP ${row.original.total_value}`,
            },
            {
                Header: t("Payment Method"),
                accessor: "payment_method",
                width: 150,
                Cell: ({ row }) => t(row.original.payment_method),
            },
            {
                Header: t("Discount"),
                accessor: "discount",
                width: 100,
                Cell: ({ row }) => row.original.discount || "--",
            },
            {
                Header: t("Profit"),
                accessor: "profit",
                width: 100,
            },
            {
                Header: t("Profit %"),
                accessor: "profit_percentage",
                width: 100,
                Cell: ({ row }) =>
                    row.original.profit_percentage != null
                        ? `${row.original.profit_percentage}%`
                        : "--",
            },
            ...(allStores
                ? [
                    {
                        Header: t("Store Name"),
                        accessor: "store_name",
                        width: 150,
                    },
                ]
                : []),
        ],
        [t, allStores]
    );

    const {
        headerGroups,
        prepareRow,
        page,
        nextPage,
        setPageSize,
        state: { pageSize },
    } = useTable(
        {
            columns,
            data,
            initialState: { pageSize: 10 },
        },
        useSortBy,
        usePagination,
        useRowSelect
    );

    const [pageIndex, setPageIndex] = useState(1);

    useEffect(() => {
        const pageDetails = {
            limit: pageSize,
            offset: pageSize * (pageIndex - 1),
        };
        if (pageSize) pagination(pageDetails);
    }, [pageSize, pageIndex, pagination]);

    const handlePageSizeChange = (newPageSize) => {
        const maxPageIndex = Math.ceil(data.length / newPageSize);
        if (pageIndex > maxPageIndex) {
            setPageIndex(maxPageIndex);
        }
        setPageSize(newPageSize);
    };

    return (
        <div className="container mx-auto mt-4 w-full">
            {additionalData?.length === 0 && !flag ? (
                <div className="h-screen w-full mt-2">
                    <ShimmerLoader />
                </div>
            ) : (
                <div className="overflow-x-auto border rounded-lg">
                    {/* Table with sticky headers */}
                    <table className="min-w-[1200px] w-full border-collapse">
                        <thead className="bg-[#78CFEC66] sticky top-0 z-10">
                            {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column) => (
                                        <th
                                            {...column.getHeaderProps(column.getSortByToggleProps())}
                                            style={{ width: column.width }}
                                            className="py-2 px-2 text-left text-sm font-semibold whitespace-nowrap"
                                        >
                                            <div className="flex items-center">
                                                {column.render("Header")}
                                                <span className="ml-1">
                                                    {column.isSorted ? (
                                                        column.isSortedDesc ? (
                                                            <img
                                                                src={Vectorsorting}
                                                                className="inline-block w-3 h-3"
                                                                alt="desc"
                                                            />
                                                        ) : (
                                                            <img
                                                                src={Vectorsorting}
                                                                className="inline-block w-3 h-3 rotate-180"
                                                                alt="asc"
                                                            />
                                                        )
                                                    ) : null}
                                                </span>
                                            </div>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>

                        <tbody className="bg-[#F7F9FD] text-center">
                            {page.map((row) => {
                                prepareRow(row);
                                return (
                                    <tr
                                        {...row.getRowProps()}
                                        className="hover:bg-white cursor-pointer border-b border-gray-300"
                                        onClick={() => onRowClick && onRowClick(row.original)}
                                    >
                                        {row.cells.map((cell) => (
                                            <td
                                                {...cell.getCellProps()}
                                                className="p-2 text-[13px] font-normal text-left"
                                                style={{ width: cell.column.width }}
                                            >
                                                {cell.render("Cell")}
                                            </td>
                                        ))}
                                    </tr>
                                );
                            })}
                            {page.length === 0 && (
                                <tr>
                                    <td colSpan={columns.length}>
                                        <Empty
                                            className="mt-10"
                                            description={t("No data available")}
                                        />
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Pagination */}
            <div className="mt-4">
                <CustomPagination
                    data={data?.length}
                    pageIndex={pageIndex}
                    pageCount={page?.length}
                    canPreviousPage={pageIndex !== 1}
                    canNextPage={data?.length === pageSize}
                    gotoPage={(p) => {
                        nextPage(p);
                    }}
                    previousPage={() => setPageIndex(pageIndex - 1)}
                    nextPage={() => setPageIndex(pageIndex + 1)}
                    pageSize={pageSize}
                    setPageSize={handlePageSizeChange}
                />
            </div>
        </div>
    );
};

export default InventoryWiseTable;
